import { ref, computed } from 'vue';
import useConfig from '@/composables/useConfig';

const flows = ref({});

export default function useFlows() {
  const { currentLanguage, activeAvatar } = useConfig();

  const languageFlow = computed(() => flows.value[activeAvatar.value][currentLanguage.value]);

  function setFlows(avatarId, data) {
    flows.value[avatarId] = data.flows;
  }

  return {
    setFlows,
    flows,
    languageFlow,
  };
}
